import { render, staticRenderFns } from "./mediationFiling_center.vue?vue&type=template&id=3ad5463a&scoped=true&"
import script from "./mediationFiling_center.vue?vue&type=script&lang=js&"
export * from "./mediationFiling_center.vue?vue&type=script&lang=js&"
import style0 from "./mediationFiling_center.vue?vue&type=style&index=0&id=3ad5463a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad5463a",
  null
  
)

export default component.exports